module.exports = __webpack_public_path__ + "static/deskimage-9f3e7dbb0ccc75fd52a8f8889563cd7f.png";